import { useEffect, useState } from "react";
import { getAppVersionLabel } from "../lib/appVersion";
import { STYX_THEME } from "../styles/theme";
import { SettingsIcon } from "./SettingsIcon";

type HeaderProps = {
  username: string;
  connectionLabel: string;
  isMobile: boolean;
  onSettings: () => void;
};

function formatClock(date: Date): string {
  return date.toLocaleTimeString("ru-RU", { hour12: false });
}

export function Header({ username, connectionLabel, isMobile, onSettings }: HeaderProps) {
  const [clock, setClock] = useState(() => formatClock(new Date()));

  useEffect(() => {
    const timer = window.setInterval(() => setClock(formatClock(new Date())), 1000);
    return () => window.clearInterval(timer);
  }, []);

  if (isMobile) {
    return (
      <div className="topbar">
        <div className="topbar__left">
          <div className="topbar__brand-block">
            <span className="topbar__brand">{STYX_THEME.appName}</span>
            <span className="topbar__version">{getAppVersionLabel()}</span>
          </div>
          <span className="topbar__user">@{username.length > 10 ? username.slice(0, 10) + "…" : username}</span>
        </div>
        <div className="topbar__right">
          <button
            type="button"
            className="topbar__btn topbar__btn--icon"
            onClick={onSettings}
            title="Настройки"
            aria-label="Настройки"
          >
            <SettingsIcon />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="topbar">
      <div className="topbar__left">
        <span className="topbar__brand">{STYX_THEME.appName}</span>
        <span className="topbar__version">{getAppVersionLabel()}</span>
        <span className="topbar__user">@{username}</span>
        <span className="topbar__connection">{connectionLabel}</span>
      </div>
      <div className="topbar__right">
        <span className="topbar__clock">{clock}</span>
        <button
          type="button"
          className="topbar__btn topbar__btn--icon"
          onClick={onSettings}
          title="Настройки"
          aria-label="Настройки"
        >
          <SettingsIcon />
        </button>
      </div>
    </div>
  );
}
